/**
 * @flow
 * @relayHash b902f996585fde225ab286cf5c343636
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POUploadStatus = "CONFIRMED" | "FAILED" | "PROCESSING" | "READY_FOR_REVIEW";
export type UploadCustomerPOInput = {|
  notes?: ?string
|};
export type UploadCustomerPOMutationVariables = {|
  input: UploadCustomerPOInput
|};
export type UploadCustomerPOMutationResponse = {|
  +uploadCustomerPO: {|
    +poUpload: {|
      +poUploadId: string,
      +fileName: string,
      +fileUrl: string,
      +status: POUploadStatus,
      +errorMessage: ?string,
      +extractedData: ?any,
      +createdAt: any,
    |}
  |}
|};
export type UploadCustomerPOMutation = {|
  variables: UploadCustomerPOMutationVariables,
  response: UploadCustomerPOMutationResponse,
|};
*/


/*
mutation UploadCustomerPOMutation(
  $input: UploadCustomerPOInput!
) {
  uploadCustomerPO(input: $input) {
    poUpload {
      poUploadId
      fileName
      fileUrl
      status
      errorMessage
      extractedData
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UploadCustomerPOInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "uploadCustomerPO",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadCustomerPOPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poUpload",
        "storageKey": null,
        "args": null,
        "concreteType": "POUpload",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "poUploadId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "errorMessage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "extractedData",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UploadCustomerPOMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UploadCustomerPOMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UploadCustomerPOMutation",
    "id": null,
    "text": "mutation UploadCustomerPOMutation(\n  $input: UploadCustomerPOInput!\n) {\n  uploadCustomerPO(input: $input) {\n    poUpload {\n      poUploadId\n      fileName\n      fileUrl\n      status\n      errorMessage\n      extractedData\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '63bc0d5fa8973e8c6a4a228d6f9031e1';
module.exports = node;
